export default "__VITE_ASSET__Dqy458Hf__"